/**
 * Maps status codes to their corresponding colors
 * @type {Object}
 */
export const statusColorMap = {
  CRTD: 'blue',
  UPDT: 'orange',
  REL: 'green',
  UNREL: 'volcano',
  DEL: 'red',
};

/**
 * Gets the color for a given status code
 * @param {string} status - The status code to get color for
 * @param {string} [defaultColor='transparent'] - Default color to return if status not found
 * @returns {string} - The color corresponding to the status
 */
export function getStatusColor(status, defaultColor = 'transparent') {
  return statusColorMap[status] || defaultColor;
}
